<template>
  <div>
    <form-accordion :title="$t('account_tb.test_validation')" :isTitleUpperCase="false">
      <b-button-group class="mt-3 mt-sm-0 shadow" style="display:grid;grid-auto-flow:column;">
        <b-button
            class="responsive-button"
            v-for="(tab, index) in tabs"
            :key="index"
            :variant="tabName === index ? 'primary' : 'secondary'"
            @click="tabName = index">
          {{ $t(tab.translationKey) }}
        </b-button>
      </b-button-group>

      <b-tabs v-model="tabName" @input="onTabChange" nav-class="d-none">
        <b-tab :title="$t('account_tb.all')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataAll" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.all") }}
              </h3>
              <pie-chart
                  id="myPieChart"
                  ref="pieChartAll"
                  :chart-data="pieChartDataAll"
                  :options="chartOptionsAll">
              </pie-chart>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('account_tb.responder')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataRes" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.responder") }}
              </h3>
              <pie-chart
                  ref="pieChartRes"
                  :chart-data="pieChartDataRes"
                  :options="chartOptionsRes">
              </pie-chart>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('account_tb.requester')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataReq" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.requester") }}
              </h3>
              <pie-chart
                  ref="pieChartReq"
                  :chart-data="pieChartDataReq"
                  :options="chartOptionsReq">
              </pie-chart>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </form-accordion>
  </div>
</template>

<script>
import {Pie} from "vue-chartjs"
import ChartDataLabels from "chartjs-plugin-datalabels"
import spinner from "@/components/common/spinner.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"


export default {
  name: 'ChartPieStat',
  components: {
    FormAccordion,
    spinner,
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  props: {
    stat: {
    },
  },
  computed: {},
  data() {
    return {
      tabName: 0,
      activateSpinnerTest: false,
      tabs: [
        {translationKey: 'account_tb.all'},
        {translationKey: 'account_tb.responder'},
        {translationKey: 'account_tb.requester'},
      ],
      chartOptionsAll: {
        responsive: true,
        aspectRatio: 1,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsReq: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsRes: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      pieChartDataAll: null,
      pieChartDataRes: null,
      pieChartDataReq: null,

    }
  },
  created() {
  },
  mounted() {

    function getValidDate(dateStr) {
      if (!dateStr) return null;
      const parsed = Date.parse(dateStr);
      return isNaN(parsed) ? null : new Date(parsed);
    }

    function computeGlobalStatus(data, type) {
      const now = new Date();
      const groupedByTestCase = {};

      data.forEach(item => {
        if (item.Type !== type) return;
        if (!item.IdTestCase || !item.IdDataset) return;

        const date = getValidDate(item.ExecutionDate);
        const testCaseId = item.IdTestCase;
        const datasetId = item.IdDataset;
        const key = `${testCaseId}_${datasetId}`;

        if (!groupedByTestCase[testCaseId]) {
          groupedByTestCase[testCaseId] = new Map();
        }

        const datasetMap = groupedByTestCase[testCaseId];

        if (!datasetMap.has(datasetId)) {
          datasetMap.set(datasetId, item);
        } else {
          const current = datasetMap.get(datasetId);
          const currentDate = getValidDate(current.ExecutionDate);

          // On remplace si :
          // - la nouvelle date est plus proche de "now"
          // - OU la date courante est absente (priorité à une vraie exécution)
          // - OU les deux sont null (on garde la dernière rencontrée)
          if (!currentDate || (date && Math.abs(date - now) < Math.abs(currentDate - now))) {
            datasetMap.set(datasetId, item);
          }
        }
      });

      const results = [];

      Object.entries(groupedByTestCase).forEach(([testCaseId, datasetMap]) => {
        let status = 'NULL'

        for (const item of datasetMap.values()) {
          const statusCode = parseInt(item.Status, 10)
          if (statusCode === 0) {
            status = '0'
            break;
          } else if (statusCode === 1 && type === 'req') {
            if (status !== 'KO') status = '1'
          } else if (statusCode === 3 && type === 'resp') {
            if (!['KO'].includes(status)) status = '3'
          } else if (statusCode === 2) {
            if (!['KO', 'CONF_NOT_FOUND'].includes(status)) status = '2'
          }
        }

        results.push({
          IdTestCase: testCaseId,
          Type: type,
          Status: status
        });
      });

      return results
    }
// Utilisation :
    // On perd les cas de test qui n ont pas de dataset associé de base
    const reqProcessed = computeGlobalStatus(this.stat, 'req')
    const respProcessed = computeGlobalStatus(this.stat, 'resp')
    const allProcessed = [...reqProcessed, ...respProcessed]

    this.generatePieChartDataStatus(allProcessed)

  },
  beforeDestroy() {
  },
  watch: {
    tabName(newVal) {
      this.$nextTick(() => {
        this.onTabChange(newVal)
      })
    }
  },
  methods: {
    onTabChange(index) {
      const charts = [
        {
          ref: this.$refs.pieChartAll,
          data: this.pieChartDataAll,
          options: this.chartOptionsAll
        },
        {
          ref: this.$refs.pieChartRes,
          data: this.pieChartDataRes,
          options: this.chartOptionsRes
        },
        {
          ref: this.$refs.pieChartReq,
          data: this.pieChartDataReq,
          options: this.chartOptionsReq
        },
      ]

      const chart = charts[index]

      if (chart && chart.ref) {
        chart.ref.renderChart(chart.data, chart.options)
      }

      // Gérer le spinner si nécessaire
      // this.$nextTick(() => {
      //   this.activateSpinner = false
      // })
    },
    generatePieChartDataStatus(data) {
      let types = ['all', 'req', 'resp']
      let pieChartData = {}

      types.forEach((type) => {
        let filteredResponses = data.filter((item) => {
          if (type === 'all') {
            return item.Type === 'resp' || item.Type === 'req'
          }
          return item.Type === type
        })

        let statusCounts = {
          OK: 0,
          KO: 0,
          NULL: 0,
          CONF_NOT_FOUND: 0,
        }

        filteredResponses.forEach((item) => {
          switch (item.Status) {
            case '2':
              statusCounts.OK++
              break
            case '0':
              statusCounts.KO++
              break
            case '3':
              if (type === 'resp' || type === 'all') statusCounts.CONF_NOT_FOUND++
              break
            default:
              statusCounts.NULL++
              break
          }
        })



        let labels = [this.$t('account_tb.status.OK'), this.$t('account_tb.status.KO'), this.$t('account_tb.status.NULL')];
        let dataValues = [statusCounts.OK, statusCounts.KO, statusCounts.NULL];
        let colors = [
          this.getCustomColor('OK', 0.8),
          this.getCustomColor('KO', 0.8),
          this.getCustomColor('NULL', 0.8),
        ]

        if (type === 'resp' || type === 'all') {
          labels.push(this.$t('account_tb.status.CONF_NOT_FOUND'))
          dataValues.push(statusCounts.CONF_NOT_FOUND)
          colors.push(this.getCustomColor('CONF_NOT_FOUND', 0.8))
        }

        pieChartData[type] = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: colors,
            },
          ],
        };
      });

      this.pieChartDataAll = pieChartData['all']
      this.pieChartDataReq = pieChartData['req']
      this.pieChartDataRes = pieChartData['resp']

      this.$nextTick(() => {
        if (this.$refs.pieChartAll) {
          this.$refs.pieChartAll.renderChart(
              this.pieChartDataAll,
              this.chartOptionsAll
          );
        }
        if (this.$refs.pieChartReq) {
          this.$refs.pieChartReq.renderChart(
              this.pieChartDataReq,
              this.chartOptionsReq
          );
        }
        if (this.$refs.pieChartRes) {
          this.$refs.pieChartRes.renderChart(
              this.pieChartDataRes,
              this.chartOptionsRes
          );
        }
      });
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'InTesting': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'CONF_NOT_FOUND': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'OK': // Bleu clair
          r = 40;
          g = 167;
          b = 69;
          break;
        case 'connector 3': // Gris neutre
        case 'NoEnrollment': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'RUN': // Vert turquoise clair
          r = 0;
          g = 158;
          b = 115;
          break;
        case 'Planned': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'KO': // Brun chaud
          r = 204;
          g = 0;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'AllTestOk': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NULL': // Rouge atténué
          r = 156;
          g = 163;
          b = 175;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
